import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  compose,
  pure,
  setDisplayName,
  setPropTypes,
  withStateHandlers
} from 'recompose';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import { Minus, Plus } from '../../../../assets/images';
import { NewModel } from '../../../model';
import { getToken, getUser, setLegalCondition } from '../../../utils/apiUser';
import Header from '../../containers/Header';
import NewsTab from '../../containers/New/NewsTab';
import WidgetList from '../../containers/WidgetList';
import LastMinute from '../../core/LastMinute';
import DataFormUser from '../DataFormUser';
import LinksIndexUser from '../LinksIndexUser';
import { StyledPlusMinus } from '../Header/style';
import MiniWidgetList from '../MiniWidgetList';
import ModalLegalWarning from '../ModalLegalWarning';
import {
  StyledBoxFixed,
  StyledBoxInside,
  StyledBoxMain,
  StyledColumn,
  StyledColumnLeft,
  StyledMiniWidgetWrap,
  StyledNewImportant,
  StyledTabs,
  StyledTabsChildren
} from './style';
import TimelineNews from './TimelineNews';

// import { FloatNotifications } from '../../containers/Notifications';

const PureMiniWidgetList = pure(MiniWidgetList);

const Home = props => {
  const [aceptLegalConditions, setaceptLegalConditions] = useState(true);
  const [hasToken, setHasToken] = useState(false);
  const [filledDataUser, setfilledDataUser] = useState(true);
  const [welcomePage, setwelcomePage] = useState(true);
  const [userId, setUserId] = useState(null);
  const [typology, setTypology] = useState(true);
  const {
    news,
    newsSticky,
    newFeatured,
    onActiveTab,
    tabActive,
    newsCurrentPage,
    loadNewsMore,
    history,
    // refreshNews,
    newsTotal
    // newsMore
  } = props;

  useEffect(() => {
    getUser().then(data => {
      setUserId(data.userId);
      setTypology(data.typology);
      setaceptLegalConditions(data.legalConditions);
      setfilledDataUser(data.filledDataUser);
      setwelcomePage(data.welcomePage);
    });
    getToken().then(data => setHasToken(data.access_token.length > 1));
  }, []);

  let content;

  switch (true) {
    case !welcomePage:
      content = <LinksIndexUser setwelcomePage={setwelcomePage} />;
      break;
    case !filledDataUser && typology !== 'INTERNAL':
      content = <DataFormUser setfilledDataUser={setfilledDataUser} />;
      break;
    default:
      content = (
        <div>
          <Helmet>
            <title>A3Mil Intranet</title>
          </Helmet>
          <Header showHeader history={history} />
          <StyledBoxMain tabs={tabActive}>
            <LastMinute />
            <StyledBoxInside>
              {newFeatured && (
                <StyledNewImportant>
                  <NewsTab
                    {...newFeatured}
                    orientation="vertical"
                    hastoken={hasToken}
                  />
                </StyledNewImportant>
              )}
              <StyledTabs>
                <StyledTabsChildren
                  active={tabActive === 1}
                  onClick={() => onActiveTab(1)}
                >
                  <StyledPlusMinus svg={Plus} />
                  1000 cosas
                </StyledTabsChildren>
                <StyledTabsChildren
                  active={tabActive === 2}
                  onClick={() => onActiveTab(2)}
                >
                  <StyledPlusMinus svg={Minus} />
                  1000 usos
                </StyledTabsChildren>
              </StyledTabs>
              <StyledColumnLeft>
                {/* <NewsMoreAdvice more={newsMore} onRefresh={refreshNews} /> */}
                {newsSticky.map(item => (
                  <NewsTab
                    {...item}
                    orientation="horizontal"
                    hastoken={hasToken}
                  />
                ))}
                <TimelineNews
                  news={news}
                  currentPage={newsCurrentPage}
                  loadMore={loadNewsMore}
                  total={newsTotal}
                  hasToken={hasToken}
                />
              </StyledColumnLeft>
              <StyledColumn>
                <StyledBoxFixed>
                  <StyledMiniWidgetWrap>
                    <PureMiniWidgetList userId={userId} />
                  </StyledMiniWidgetWrap>
                  <WidgetList />
                </StyledBoxFixed>
              </StyledColumn>
            </StyledBoxInside>
          </StyledBoxMain>
          {!aceptLegalConditions && (
            <ModalLegalWarning
              typology={typology}
              setaceptLegalConditions={setaceptLegalConditions}
              onAceptLegal={setLegalCondition}
            />
          )}
        </div>
      );
  }

  return <div>{content}</div>;
};

export default compose(
  setDisplayName('HomeView'),
  withStateHandlers(
    ({ initialTabActive = 1 }) => ({
      tabActive: initialTabActive
    }),
    {
      onActiveTab: () => value => ({ tabActive: value })
    }
  ),
  setPropTypes({
    news: PropTypes.arrayOf(NewModel),
    newFeatured: NewModel,
    newsSticky: PropTypes.arrayOf(NewModel),
    newsCurrentPage: PropTypes.number,
    tabActive: PropTypes.number,
    loadNewsMore: PropTypes.func,
    newsTotal: PropTypes.number,
    newsMore: PropTypes.bool
  }),
  pure
)(Home);
